import { useAuth } from '../auth/AuthContext';

/**
 * Devuelve el jugador actual desde el AuthContext (sin llamadas API adicionales).
 * El player se carga una sola vez al iniciar sesión y se comparte globalmente.
 */
export function useCurrentPlayer() {
    const { player, loading } = useAuth();
    return { player, loading, error: null };
}
